module.exports = __webpack_public_path__ + "img/upucivanje.d8c4e25c.png";